import { website, enterprise, enableLogoLink } from 'config/system';
import React from 'react';
import * as styles from './styles';

const Logo = () => {
  const title = enterprise.is
    ? ''
    : 'SurveyCake 協助你建立專業、友善的線上問卷';
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      className={styles.logo}
      target="_blank"
      title={title}
      href={enableLogoLink ? website : undefined}
      aria-label="logo"
      rel="noopener noreferrer"
    />
  );
};

export default Logo;
